import React, {useContext} from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import {LanguageContext} from "../../context/LanguageContext";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import Grid from "@mui/material/Grid";
import PersonIcon from "@mui/icons-material/Person";
import Typography from "@mui/material/Typography";
import {getUserFullNameByLang} from "../../utils/commonFunctions";
import Rendered from "../Rendered";
import Icon from "@mui/material/Icon";
import {UserContext} from "../../context/UserContext";

const UserMenuMobileDialog = props => {
  const {open, handleClose, buttonList} = props;
  const languageContext = useContext(LanguageContext);
  const userContext = useContext(UserContext);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle color="secondary">
        <Grid container spacing={1} alignContent="center" alignItems="center">
          <Grid item alignContent="center" alignItems="center" display="flex">
            <PersonIcon/>
          </Grid>
          <Grid item>
            {getUserFullNameByLang(userContext.userInfo.firstName, userContext.userInfo.lastName, languageContext.language.id)}
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container rowSpacing={2}>
          {buttonList?.map((button, index) => (
            <Grid item xs={12} key={index}>
              <Rendered rendered={!button.hidden}>
                <Button
                  onClick={() => {
                    handleClose();
                    button.onClick?.();
                  }}
                  fullWidth
                  variant="contained"
                  color="mainButton"
                  startIcon={<Icon>{button.icon}</Icon>}
                  size="large"
                  sx={{justifyContent: "flex-start", textAlign: "left"}}
                >
                  <Typography sx={{fontWeight: "bold"}}>
                    {button.label}
                  </Typography>
                </Button>
              </Rendered>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions sx={{paddingTop: 2, paddingRight: 3}}>
        <Button onClick={handleClose} color="primary">
          {languageContext.dictionary.close}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

UserMenuMobileDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  buttonList: PropTypes.array.isRequired
};

export default UserMenuMobileDialog;